import type { Meta, StoryFn } from '@storybook/react';

import { EmailDisplay } from '@pega/cosmos-react-core';
import type { EmailDisplayProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Email',
  component: EmailDisplay
} as Meta;

export const EmailDisplayDemo: StoryFn<EmailDisplayProps> = (args: EmailDisplayProps) => {
  return <EmailDisplay value={args.value} displayText={args.displayText} variant={args.variant} />;
};

EmailDisplayDemo.args = {
  value: 'email@example.com',
  displayText: 'Example Email',
  variant: 'link'
};

EmailDisplayDemo.argTypes = {
  value: { control: { type: 'text' } },
  displayText: { control: { type: 'text' } },
  variant: { options: ['link', 'text'], control: { type: 'select' } }
};
